import { render, staticRenderFns } from "./AddDocumentVersionDialog.vue?vue&type=template&id=919193f0&scoped=true"
import script from "./AddDocumentVersionDialog.vue?vue&type=script&lang=js"
export * from "./AddDocumentVersionDialog.vue?vue&type=script&lang=js"
import style0 from "./AddDocumentVersionDialog.vue?vue&type=style&index=0&id=919193f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "919193f0",
  null
  
)

export default component.exports